import {StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../theme';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  value: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey9,
    marginRight: 4,
  },
  title: {
    fontSize: 11,
    fontFamily: textStyles.regular,
    color: colorPalette.grey4,
  },
});
